import { useForm } from '../../context/FormContext'
import FormField from '../ui/FormField'
import Select from '../ui/Select'
import FileUpload from '../ui/FileUpload'
import ar from '../../locales/ar.json'

const t  = ar.step2
const t2 = ar.app

const MARITAL_OPTIONS = [
  { value: 'أعزب',  label: t.marital_single  },
  { value: 'متزوج', label: t.marital_married  },
  { value: 'مطلق',  label: t.marital_divorced },
  { value: 'أرمل',  label: t.marital_widowed  },
]
const ACCURACY_OPTIONS = [
  { value: 'دقيق',    label: t.accuracy_exact  },
  { value: 'تقريبي', label: t.accuracy_approx  },
]
const CONSENT_OPTIONS = [
  { value: 'نشر عام',               label: t.consent_public   },
  { value: 'للنشر الداخلي فقط',     label: t.consent_internal },
  { value: 'عدم النشر',             label: t.consent_no_publish },
]

export default function Step2_MartyrInfo() {
  const { state, updateField, setFile } = useForm()
  const { formData, files, errors } = state

  const field = (id) => ({ id, error: errors[id] })

  return (
    <div>
      <h2 className="section-title">
        <span className="bg-primary-700 text-white w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">٢</span>
        {t.sectionTitle}
      </h2>

      {/* Martyr full name */}
      <FormField {...field('martyr_fullname')} label={t.martyr_fullname} required>
        <input
          id="martyr_fullname"
          type="text"
          value={formData.martyr_fullname}
          onChange={(e) => updateField('martyr_fullname', e.target.value)}
          className="input-base"
          aria-required="true"
          dir="rtl"
        />
      </FormField>

      {/* Mother name */}
      <FormField {...field('mother_name')} label={t.mother_name} required>
        <input
          id="mother_name"
          type="text"
          value={formData.mother_name}
          onChange={(e) => updateField('mother_name', e.target.value)}
          className="input-base"
          aria-required="true"
          dir="rtl"
        />
      </FormField>

      {/* Birth date + accuracy */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormField {...field('birth_date')} label={t.birth_date}>
          <input
            id="birth_date"
            type="text"
            value={formData.birth_date}
            onChange={(e) => updateField('birth_date', e.target.value)}
            className="input-base"
            placeholder="مثال: 1985 أو 1985-06-15"
            dir="ltr"
            style={{ textAlign: 'right' }}
          />
        </FormField>
        <Select
          {...field('birth_date_accuracy')}
          label={t.birth_date_accuracy}
          value={formData.birth_date_accuracy}
          onChange={(v) => updateField('birth_date_accuracy', v)}
          options={ACCURACY_OPTIONS}
        />
      </div>

      {/* Current residence */}
      <FormField {...field('current_residence')} label={t.current_residence} required>
        <input
          id="current_residence"
          type="text"
          value={formData.current_residence}
          onChange={(e) => updateField('current_residence', e.target.value)}
          className="input-base"
          aria-required="true"
          dir="rtl"
          placeholder="آخر مكان إقامة معروف"
        />
      </FormField>

      {/* Civil registry */}
      <FormField {...field('civil_registry_place')} label={t.civil_registry_place} required>
        <input
          id="civil_registry_place"
          type="text"
          value={formData.civil_registry_place}
          onChange={(e) => updateField('civil_registry_place', e.target.value)}
          className="input-base"
          aria-required="true"
          dir="rtl"
          placeholder="مثال: دمشق — القنوات"
        />
      </FormField>

      {/* Marital status */}
      <Select
        {...field('marital_status')}
        label={t.marital_status}
        required
        value={formData.marital_status}
        onChange={(v) => updateField('marital_status', v)}
        options={MARITAL_OPTIONS}
        placeholder={t2.select}
      />

      {/* Photo upload */}
      <div className="mt-6 pt-4 border-t border-stone-100">
        <h3 className="text-base font-semibold text-primary-700 mb-3">{t.photoSection}</h3>
        <FileUpload
          id="martyr_photo_upload"
          label={t.martyr_photo_upload}
          accept="image/jpeg,image/png"
          multiple={false}
          files={files.martyr_photo_upload ? [files.martyr_photo_upload] : []}
          onAdd={(fs) => setFile(fs[0])}
          onRemove={() => setFile(null)}
          hint={t.photo_hint}
        />

        {/* Photo consent — only if photo is uploaded */}
        {files.martyr_photo_upload && (
          <Select
            id="photo_publish_consent"
            label={t.photo_publish_consent}
            value={formData.photo_publish_consent}
            onChange={(v) => updateField('photo_publish_consent', v)}
            options={CONSENT_OPTIONS}
            placeholder={t2.select}
          />
        )}
      </div>
    </div>
  )
}
